import React from "react";
import ImageLoader from "react-load-image";
import defaultUser from "../../../../assets/user.png";
import Preloader from "../../../../utilities/components/Preloader/Preloader";

const ProfileImage = ({patient, classes}) => {
  return (
    <ImageLoader
      src={patient.imageUrl ? patient.imageUrl : defaultUser}
    >
      <img alt="profile" className={classes.profileImage}/>
      <div className={classes.profileImageError}>
        {patient.id}
      </div>
      <Preloader className={classes.profileImage}/>
    </ImageLoader>
  );
};

export default ProfileImage;
